export default __webpack_public_path__ + "static/media/2362.b326e3ab.png";